// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { LayoutComponent } from "@ifeng-fe/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { ImageLink } from "@ifeng-fe/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { Nav_1 } from "@ifeng-fe/lowcode_basic/src/components/nav/Nav_1/index.tsx";

import { Container } from "@ifeng-fe/lowcode_basic/src/components/layout/Container/index.tsx";

import { Row } from "@ifeng-fe/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng-fe/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng-fe/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng-fe/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng-fe/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_12 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_12/index.tsx";

import { Tabs } from "@ifeng-fe/lowcode_basic/src/components/layout/Tabs/index.tsx";

import { TabPanel, Swiper_5 } from "@ifeng-fe/lowcode_basic/src/index.tsx";

import { NewList_9 } from "@ifeng-fe/lowcode_business/src/components/newList/NewList_9/index.tsx";

import { Footer } from "@ifeng-fe/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div
        style={{ overflowX: "hidden" }}
        hoverStyle=""
        nodeId="node_dockcviv8fo1"
      >
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl8lkjm3v1i"
          hoverStyle=""
        >
          <ImageLink
            image="https://x0.ifengimg.com/ucms/2026_10/3F3B213588416F7FD9303DB184627B6B9156BC42_size488_w3840_h700.jpg"
            url=""
            isBlock={true}
            width={300}
            height={350}
            objectFit="cover"
            style={{
              display: "block",
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              backgroundSize: "cover",
            }}
            hoverStyle=""
            nodeId="node_ocl8mrdjw62"
          />
          <Nav_1
            navChip={{
              $data: true,
              id: "261122",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260297" },
              uuid: "1fb1fb30",
              force: 1773203120648,
            }}
            mainWidth={1000}
            height={80}
            backgroundColor="#d41e26"
            isHasLeftImage={true}
            isSubTitleUnderline={true}
            subTitleHoverColor="#ffffff"
            subTitleStyle={{
              color: "#ffffff",
              fontSize: "16px",
              fontWeight: 400,
            }}
            titleStyle={{
              color: "#ffffff",
              fontSize: "24px",
              fontWeight: 700,
              lineHeight: "28px",
              width: "20px",
            }}
            leftImageUrl="https://x0.ifengimg.com/ucms/2022_42/F97C21F25CC12931F992999D5ABA015D2C64A8AF_size66_w1754_h417.png"
            leftImageStyle={{ marginRight: "80px" }}
            isSticky={false}
            style={{ paddingRight: "20px", paddingLeft: "20px" }}
            hoverStyle=""
            leftImageWidth={120}
            nodeId="node_ocl8mrdjw63"
          />
        </LayoutComponent>
        <Container
          width={1200}
          isCenter={true}
          hoverStyle=""
          nodeId="node_ocl8lkjm3v1n"
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8lkjm3v1o"
            hoverStyle=""
          >
            <Row
              isCenter={true}
              justifyContent="flex-start"
              alignItems="stretch"
              hoverStyle=""
              style={{ paddingBottom: "10px" }}
              nodeId="node_ocl8mrdjw64"
            >
              <Col
                width={{ size: 800, type: "px" }}
                style={{
                  paddingRight: "20px",
                  marginTop: "40px",
                  marginBottom: "20px",
                }}
                hoverStyle=""
                nodeId="node_ocl8u2cvve1g"
              >
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2024_09/0E7725A55BE9D010CC36EF0EDF53CFCB07D394D7_size3_w780_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    fontWeight: 700,
                    fontSize: "26px",
                    marginRight: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    marginTop: "30px",
                    marginRight: "20px",
                    marginBottom: "20px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  hoverStyle=""
                  isTextHasIcon={false}
                  nodeId="node_ocl8u2cvve1w"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "289231",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "3087fd86",
                    force: 1772447245683,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    fontWeight: 700,
                    lineHeight: "26px",
                    paddingBottom: "15px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  hoverStyle=""
                  style={{ paddingRight: "20px" }}
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderColor: "#dadada",
                  }}
                  nodeId="node_ocl96p0d0t3"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "289232",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "e7b43428",
                    force: 1773372374453,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    lineHeight: "26px",
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px", paddingBottom: "20px" }}
                  hoverStyle=""
                  itemStyle={{
                    borderBottomStyleType: "solid",
                    borderBottomStyleColor: "#ebebeb",
                    marginTop: "24px",
                    borderStyle: "none",
                  }}
                  nodeId="node_ocl8u2cvve1o"
                />
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_09/AD42AB86DB762378BCE9751F43453FD729A30DAA_size4_w780_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#c33430",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    backgroundColor: "#ffffff",
                    marginRight: "20px",
                    marginBottom: "10px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u8dees9g"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "289233",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "f4732ef5",
                    force: 1773372407028,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "14px",
                    lineHeight: "26px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{ fontSize: "14px", lineHeight: "26px" }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px" }}
                  hoverStyle=""
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderBottomWidth: "1px",
                    borderBottomStyle: "solid",
                    borderBottomColor: "#ebebeb",
                  }}
                  nodeId="node_ocl8u8dees9a"
                />
              </Col>
              <Col
                width={{ size: 380, type: "px" }}
                style={{ marginBottom: "20px", marginTop: "40px" }}
                hoverStyle=""
                nodeId="node_ocl8u2cvve1j"
              >
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2023_09/4584615CA13E5290DFC97CC2D06AC342582EDD36_size4_w380_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    marginTop: "30px",
                    height: "40px",
                    marginBottom: "20px",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve23"
                />
                <Swiper_1
                  swiperChip={{
                    $data: true,
                    id: "289234",
                    type: "recommend",
                    title: "轮播图内容",
                    default: { type: "recommend", id: "285915" },
                    uuid: "ee7a9cb2",
                    force: 1772441026441,
                  }}
                  height={213}
                  loop={false}
                  isHasNav={false}
                  leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                  rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                  navWidth={15}
                  navHeight={20}
                  navY={85}
                  navX={10}
                  isAutoPlay={true}
                  autoSpeed={3000}
                  skin={1}
                  isHasTitle={true}
                  titleHeight={36}
                  titleStyle={{
                    background: "linear-gradient(180deg,transparent,#000)",
                    color: "#fff",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  isHasPagination={false}
                  paginationPosition="titleBottom"
                  paginationNormalStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    borderTopLeftRadius: "50px",
                    borderTopRightRadius: "50px",
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                    width: "4px",
                    height: "4px",
                    marginLeft: "4px",
                    marginRight: "4px",
                  }}
                  paginationActiveStyle={{
                    borderTopLeftRadius: "2px",
                    borderTopRightRadius: "2px",
                    borderBottomLeftRadius: "2px",
                    borderBottomRightRadius: "2px",
                    width: "12px",
                  }}
                  paginationTotalStyle={{ marginBottom: "10px" }}
                  style={{ paddingTop: "10px" }}
                  hoverStyle=""
                  nodeId="node_ocl8uc1v7t4"
                />
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2024_09/085C1421FBB3303ACE8AC176CB767D3D3E2C5B40_size4_w380_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{ marginTop: "20px", height: "40px" }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve24"
                />
                <VideoList_1
                  videoChip={{
                    $data: true,
                    id: "289235",
                    type: "recommend",
                    title: "视频列表",
                    format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                    default: { type: "recommend", id: "285924" },
                    uuid: "c1b22e85",
                    force: 1772441062204,
                  }}
                  width={380}
                  height={213}
                  autoPlay={false}
                  controls={true}
                  hoverColor="#ba2636"
                  skin={0}
                  continuePlay={false}
                  style={{ marginTop: "20px" }}
                  listHeight={48}
                  listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
                  listIconWidth={14}
                  listIconHeight={9}
                  listStyle={{
                    paddingLeft: "0px",
                    paddingRight: "10px",
                    height: "36px",
                    fontSize: "14px",
                    color: "#2b2b2b",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve1n"
                />
              </Col>
            </Row>
          </LayoutComponent>
          <Container isCenter={true} nodeId="node_ocmmetfse3z">
            <LayoutComponent isCenter={true} nodeId="node_ocmmetfse31d">
              <Title
                text=""
                height={50}
                image="https://x0.ifengimg.com/ucms/2026_10/6E993F2C0A3E9A79001564DB229F9FFC36F0CED3_size21_w1192_h50.png"
                textAlign="flex-start"
                textStyle={{
                  paddingLeft: "24px",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "24px",
                }}
                isTextHasIcon={false}
                textIconHeightFull={true}
                isHasAddonAfter={false}
                addonAfterText="更多"
                addonAfterTextStyle={{
                  fontSize: "14px",
                  color: "#ffffff",
                  textDecoration: "underline",
                }}
                nodeId="node_ocltcd3vjf1p"
                hoverStyle=""
                style={{
                  marginBottom: "20px",
                  fontSize: "36px",
                  fontWeight: "700",
                  color: "#ecebef",
                  marginTop: "20px",
                }}
              />
              <NewsList_12
                newsChip={{
                  $data: true,
                  id: "289301",
                  type: "recommend",
                  title: "新闻内容",
                  default: { type: "recommend", id: "285873" },
                  uuid: "72a502ef",
                  force: 1773113620035,
                }}
                colNum={3}
                thumbnailWidth={383}
                thumbnailHeight={215}
                showThumbnailHoverScale={true}
                isHasTitle={true}
                titleRows={2}
                titleHoverColor="#ba2636"
                titleStyle={{
                  paddingTop: "15px",
                  color: "#2b2b2b",
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 700,
                  marginBottom: "10px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
                showSummary={false}
                summaryStyle={{
                  color: "#666666",
                  fontSize: "15px",
                  lineHeight: "26px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
                moreText="[详细]"
                moreStyle={{ color: "#ba2636" }}
                itemStyle={{
                  borderColor: "#ebebeb",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                formatImageType={0}
                nodeId="node_ocl89zej7q1n"
                hoverStyle=""
                style={{ marginBottom: "20px" }}
                summaryRows={3}
              />
            </LayoutComponent>
          </Container>
        </Container>
        <Container
          width={1200}
          isCenter={true}
          nodeId="node_ocltcd3vjff"
          hoverStyle=""
          style={{ marginBottom: "10px" }}
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocmmekgtrx1"
            hoverStyle=""
          >
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2026_10/8470227579DE4FF73960B3429E8D8773D951C4A2_size21_w1192_h50.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                color: "#ffffff",
                fontWeight: 700,
                fontSize: "24px",
              }}
              isTextHasIcon={false}
              textIconHeightFull={true}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              nodeId="node_ocltcd3vjf1p"
              hoverStyle=""
              style={{
                marginBottom: "20px",
                fontSize: "36px",
                fontWeight: "700",
                color: "#ecebef",
                marginTop: "20px",
              }}
            />
            <Tabs
              tabList={[
                {
                  id: "667391c5-a1bc-461f-9035-3f9be06e9cab",
                  title: "外交主题记者会",
                },
                {
                  id: "98652100-f12b-445d-805d-47c822b77852",
                  title: "经济主题记者会",
                },
                {
                  id: "f097de25-5aba-4d93-94c3-84ff95435115",
                  title: "民生主题记者会",
                },
                { title: "政府工作报告", id: "2" },
                { title: "人大发布会", id: "" },
              ]}
              tabWidth={250}
              tabHeight={40}
              tabGap={10}
              contentGap={20}
              tabStyle={{
                borderWidth: "1px",
                borderColor: "#c3c3c3",
                borderStyle: "solid",
                borderTopWidth: "1px",
                fontWeight: "400",
                fontSize: "20px",
              }}
              tabActiveStyle={{
                fontSize: "20px",
                fontWeight: "700",
                backgroundColor: "#c33430",
                color: "#ffffff",
              }}
              nodeId="node_ocltcd3vjft"
              hoverStyle=""
            >
              <TabPanel
                panelId="fd9d55a7-8ac5-41ad-9131-d34fc3813399"
                nodeId="node_oclth0q3gk1"
                hoverStyle=""
              >
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "289294",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "8cb84f29",
                    force: 1773025971915,
                  }}
                  hoverColor="#ba2636"
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocltcd3vjfy"
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel
                panelId="667391c5-a1bc-461f-9035-3f9be06e9cab"
                nodeId="node_ocltfsi9h43"
              >
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "289295",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "0afd1ad6",
                    force: 1773030734054,
                  }}
                  hoverColor="#ba2636"
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocltcd3vjfy"
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel panelId="98652100-f12b-445d-805d-47c822b77852">
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "289293",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "ede15d17",
                    force: 1773025757868,
                  }}
                  hoverColor="#ba2636"
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocltmfu63v2"
                />
              </TabPanel>
              <TabPanel
                panelId="f097de25-5aba-4d93-94c3-84ff95435115"
                nodeId="node_ocltecfcf24"
              >
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "289296",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "801b403e",
                    force: 1773026152605,
                  }}
                  hoverColor="#ba2636"
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocltcd3vjfy"
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel panelId="2">
                <NewList_9
                  newsChip={{
                    $data: true,
                    id: "289297",
                    type: "recommend",
                    title: "新闻列表",
                    default: { type: "recommend", id: "287646" },
                    uuid: "ae2f9ec2",
                    force: 1773202442243,
                  }}
                  hoverColor="#ba2636"
                  bigImageWidth={793}
                  imageWidth={386}
                  nodeId="node_ocltcd3vjfy"
                  hoverStyle=""
                />
              </TabPanel>
            </Tabs>
          </LayoutComponent>
        </Container>
        <Container
          width={1200}
          isCenter={true}
          hoverStyle=""
          nodeId="node_ocl988i9ym1"
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8u8dees77"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          />
        </Container>
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl988i9ym2"
          hoverStyle=""
        >
          <Title
            text=""
            height={50}
            image="https://x0.ifengimg.com/ucms/2024_09/8BA2A44E9FE5DDD98B878888496C3676789776CE_size26_w1192_h50.jpg"
            textAlign="flex-start"
            textStyle={{
              paddingLeft: "24px",
              fontWeight: 700,
              fontSize: "20px",
            }}
            isHasAddonAfter={false}
            addonAfterText="更多"
            addonAfterTextStyle={{
              fontSize: "14px",
              color: "#ffffff",
              textDecoration: "underline",
            }}
            style={{
              fontSize: "36px",
              fontWeight: "700",
              color: "#ecebef",
              width: "1200px",
              margin: "0 auto",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            isTextHasIcon={false}
            hoverStyle=""
            nodeId="node_ocl93sv4mm2"
          />
          <Swiper_5
            swiperChip={{
              $data: true,
              id: "289243",
              type: "recommend",
              title: "轮播图数据",
              default: { type: "recommend", id: "286116" },
              uuid: "87862fa0",
              force: 1772436027301,
            }}
            swiperWidth={1200}
            height={595}
            formatImageType={0}
            isAutoPlay={true}
            autoSpeed={3000}
            isHasNav={true}
            leftNavImage="http://p2.ifengimg.com/l/2018/5/15a8462c875f75e/leftButton.png"
            rightNavImage="http://p1.ifengimg.com/l/2018/5/15a8462c875f75e/rightButton.png"
            navWidth={57}
            navHeight={64}
            navY={220}
            navX={1250}
            isHasTitle={true}
            titleLeft={0}
            titleRight={0}
            titleY={60}
            titleStyle={{
              color: "#ffffff",
              fontSize: "20px",
              lineHeight: "28px",
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              paddingTop: "15px",
              paddingRight: "20px",
              paddingBottom: "15px",
              paddingLeft: "20px",
            }}
            hoverStyle=""
            style={{ marginBottom: "20px" }}
            nodeId="node_ocl8u8dees97"
          />
        </LayoutComponent>
        <Container
          isCenter={true}
          nodeId="node_oclejrhbo23i"
          hoverStyle=""
          width={1200}
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_oclepsnb3t1"
            hoverStyle=""
          >
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2026_10/1A46DF4725FEF1947B3DA1D305E635E367379C4A_size28_w1192_h50.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                fontSize: "36px",
                fontWeight: "700",
                color: "#ecebef",
                width: "1200px",
                margin: "0 auto",
                marginBottom: "20px",
                marginTop: "20px",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "289244",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "8e4f8a3e",
                force: 1773372709427,
              }}
              colNum={3}
              thumbnailWidth={383}
              thumbnailHeight={215}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                paddingTop: "15px",
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              showSummary={false}
              summaryStyle={{
                color: "#666666",
                fontSize: "15px",
                lineHeight: "26px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              itemStyle={{
                borderColor: "#ebebeb",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
              formatImageType={0}
              nodeId="node_ocl89zej7q1n"
              hoverStyle=""
              style={{ marginBottom: "20px" }}
              summaryRows={3}
            />
          </LayoutComponent>
          <Container isCenter={true} nodeId="node_ocmmj51lac1">
            <LayoutComponent isCenter={true} nodeId="node_ocmmj51lac2">
              <Title
                text=""
                height={50}
                image="https://x0.ifengimg.com/ucms/2026_11/41E57750F2353F84D7603C48238EECB4B5B661A7_size21_w1192_h50.png"
                textAlign="flex-start"
                textStyle={{
                  paddingLeft: "24px",
                  fontWeight: 700,
                  fontSize: "20px",
                }}
                isHasAddonAfter={false}
                addonAfterText="更多"
                addonAfterTextStyle={{
                  fontSize: "14px",
                  color: "#ffffff",
                  textDecoration: "underline",
                }}
                style={{
                  fontSize: "36px",
                  fontWeight: "700",
                  color: "#ecebef",
                  width: "1200px",
                  margin: "0 auto",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
                isTextHasIcon={false}
                hoverStyle=""
                nodeId="node_ocl93sv4mm2"
              />
            </LayoutComponent>
            <Container isCenter={true} nodeId="node_ocmmj51lac4">
              <NewsList_12
                newsChip={{
                  $data: true,
                  id: "289347",
                  type: "recommend",
                  title: "新闻内容",
                  default: { type: "recommend", id: "287410" },
                  uuid: "45859417",
                  force: 1773111063235,
                }}
                colNum={3}
                thumbnailWidth={383}
                thumbnailHeight={215}
                showThumbnailHoverScale={true}
                formatImageType={1}
                isHasTitle={true}
                titleRows={2}
                titleHoverColor="#ba2636"
                titleStyle={{
                  paddingTop: "15px",
                  color: "#2b2b2b",
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 700,
                  marginBottom: "10px",
                }}
                showSummary={false}
                summaryRows={3}
                summaryStyle={{
                  color: "#666666",
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
                moreText="[详细]"
                moreStyle={{ color: "#ba2636" }}
                nodeId="node_ocmmj51lac6"
                hoverStyle=""
                style={{ marginBottom: "20px" }}
              />
            </Container>
          </Container>
          <Container isCenter={true} nodeId="node_oclepbo85c4" hoverStyle="">
            <Title
              text=""
              height={50}
              image="https://x0.ifengimg.com/ucms/2026_10/F2A3238B41543B05BFD9A11A600447F83286E3C4_size20_w1192_h50.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "20px",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                backgroundColor: "#c33430",
                fontSize: "36px",
                fontWeight: 700,
                color: "#ecebef",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm2"
            />
            <Container
              isCenter={true}
              nodeId="node_oclepbo85c5"
              hoverStyle=""
              style={{ textAlign: "center", margin: "40px 0 40px" }}
            />
            <Container
              isCenter={true}
              nodeId="node_oclepbo85c7"
              hoverStyle=""
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2024_09/D774C89EA4231D8C622BBD6A328375481B8E07D7_size192_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{ height: "auto" }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_09/EE3688E09CBC47F6DEBC31B9C53A66D71128866B_size180_w1500_h600.png"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={300}
              />
              <ImageLink
                image=""
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{
                  height: "auto",
                  border: "1px solid rgba(34,34,34, .1)",
                  marginBottom: "26px",
                }}
                height={200}
              />
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2023_10/A3836B6B2214D84DC4213B5B665843FC6D203DBA_size11_w1500_h600.jpg"
                url=""
                isBlock={false}
                width={285}
                objectFit=""
                nodeId="node_oclepbo85c9"
                hoverStyle=""
                style={{ height: "auto", marginBottom: "26px" }}
                height={200}
              />
            </Container>
          </Container>
        </Container>
        <Footer
          year="2022"
          style={{ marginTop: "70px" }}
          hoverStyle=""
          textColor="#212223"
          nodeId="node_ocl8u8dees9i"
        />
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
